import { FC, ReactNode } from 'react'
import { Text } from '@/atoms/Text'
import type { NamedColor } from '@/constants/types'

type DetailItemType = {
  text: string | number
  textColor?: NamedColor
  icon?: ReactNode
}
export const DetailItem: FC<DetailItemType> = ({ text, textColor, icon }) => {
  return (
    <div className="flex items-center gap-[2px]">
      {icon}
      <Text color={textColor ?? 'white'} className="photon-caption-sm md:photon-paragraph-lg">
        {text}
      </Text>
    </div>
  )
}
